import { GET_PRECALIFICACION} from './../constants';
import { handleActions } from "redux-actions"

export const precalificacion  = handleActions(
  { 
    [ GET_PRECALIFICACION ]: (state, action) => {
        return action.payload[0]
    },
  }, {}
)